import update from 'immutability-helper';
import {
  mapValues,
  merge,
  unset,
} from 'lodash/fp';
import typeToReducer from 'type-to-reducer';

import * as types from './types';

const initialState = {};

export default typeToReducer({
  [types.TODOS_MERGE]: (state, action) => {
    const { payload: newToDos } = action;
    return merge(state, newToDos);
  },
  [types.TODO_CREATE]: {
    FULFILLED: (state, action) => {
      const { payload: newToDos } = action;
      return merge(state, newToDos);
    },
  },

  [types.TODO_CHANGE]: (state, action) => {
    const { id, data } = action;
    return update(state, {
      [id]: { $merge: data },
    });
  },

  [types.TODO_DELETE]: {
    FULFILLED: (state, action) => {
      const { meta: { id } } = action;
      return unset(id)(state);
    },
  },

  [types.TODO_SELECT]: (state, action) => {
    const { id } = action;

    return _.mapValues(state, (toDoItem) => {
      if (id && toDoItem.id === id) {
        return update(toDoItem, {
          selected: { $set: true },
        });
      }
      return update(toDoItem, {
        selected: { $set: false },
      });
    });
  },
  [types.TODO_SAVE]: {
    PENDING: (state, action) => {
      const { id } = action.meta;

      return update(state, {
        [id]: {
          isLoading: { $set: true },
          errored: { $set: false },
        },
      });
    },
    FULFILLED: state => mapValues(todo => merge(todo, {
      isLoading: false,
      errored: false,
    }))(state),


    REJECTED: (state, action) => {
      const { id } = action.meta;
      return update(state, {
        [id]: {
          isLoading: { $set: false },
          errored: { $set: true },
        },
      });
    },
  },
}, initialState);
